import React from 'react';
import PropTypes from 'prop-types';

const RecordNumber = ({ data }) => {
  let displayText = data.toString();
  if (data < 100) {
    displayText = "0" + displayText;
    if (data < 10)
    {
      displayText = "0" + displayText;
    }
  }
  return (
    <span>{displayText}</span>
  );
};

RecordNumber.propTypes = {
  data: PropTypes.number,
};

export default RecordNumber;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/RecordNumber.js